import { Col } from "react-bootstrap";
import { BsFillBoxFill } from "react-icons/bs";
import { FaAddressCard } from "react-icons/fa6";
import { useLocation } from "react-router-dom";
import getBoxSize from "../../../function/getBoxSize";
import getShipmentStatus from "../../../function/getShipmentStatus";
import DownloadFactor from "../../home/DownloadFactor";

const SuccessShipmentBox = ({ shipment, isTrack = false }) => {
  const { pathname } = useLocation();

  return (
    <Col
      xs={12}
      className={
        "d-flex flex-column border border-2 rounded-2 px-3 py-3 row-gap-2" +
        (!isTrack ? " w-lg-48" : "")
      }
    >
      <div className="d-flex flex-wrap justify-content-between align-items-center">
        <div>
          <span>شماره سفارش: </span>
          <span className="fs-5 fw-bold color-avaex-second">
            {shipment.numberParcel}
          </span>

          <p className="mt-2 mb-0">
            <span>بارکد: </span>
            <span className="fs-5 color-avaex-second">{shipment.barcode}</span>
          </p>

          {shipment.agent && (
            <p className="mt-2 mb-0">
              <span>نمایندگی مبدا: </span>
              <span className="fw-bold">{shipment.agent.province.faName} </span>
              <span className="fw-bold">{shipment.agent.city.faName} </span>
              <span className="fw-bold">
                (کد: {shipment.agent.contractNumber})
              </span>
            </p>
          )}

          {shipment.pre_order_code && (
            <p className="mt-2 mb-0">
              <span>کد پیش سفارش: </span>
              <span className="fs-5" style={{ letterSpacing: 4 }}>
                {shipment.pre_order_code.code}
              </span>
            </p>
          )}
        </div>

        {isTrack && (
          <DownloadFactor
            id={shipment.id}
            numberParcel={shipment.numberParcel}
          />
        )}
      </div>

      <hr />

      <div className="d-flex flex-wrap justify-content-around mb-3">
        <div className="w-100 d-flex flex-wrap justify-content-around border border-1 rounded-1 px-4 py-2 mb-3 align-items-center mx-3 row-gap-3">
          <div className="d-flex flex-wrap gap-3">
            <div>
              <p>
                <span>سرویس دهنده: </span>
                <span className="fs-5 fw-bold">{shipment.company.name}</span>
              </p>
              <p className="mb-0">
                <span>نوع سرویس: </span>
                <span className="fs-5 fw-bold">
                  {shipment.company_type_post.name}
                </span>
              </p>
            </div>
            <div>
              <img
                style={{ width: 120, height: 70, objectFit: "contain" }}
                src={shipment.company.image}
              />
            </div>
          </div>

          <div
            className="py-2 px-3 rounded-1"
            style={{ backgroundColor: "#eaebeb" }}
          >
            <span>وضعیت: </span>
            <span className="fs-6 fw-bold">
              {getShipmentStatus(shipment.status)}
            </span>
          </div>
          <div
            className="py-2 px-3 rounded-1"
            style={{ backgroundColor: "#eaebeb" }}
          >
            <span>نوع پرداخت: </span>
            <span className="fs-6 fw-bold">{shipment.methodPaymentName}</span>
          </div>
        </div>

        <div
          className={`border border-1 rounded-2 p-2 col-12 w-xl-45 ${
            pathname === "/tracking" ? "d-flex column-gap-2" : ""
          } justify-content-evenly mt-3`}
        >
          <div className="text-center">
            <FaAddressCard size={80} color="#482b88" />
          </div>

          <div>
            <p className="mt-1">
              <span className="fw-bold">نام فرستنده: </span>
              {shipment.source.type === 0 && (
                <span>
                  {shipment.source.name + " " + shipment.source.family}
                </span>
              )}
              {shipment.source.type === 1 && (
                <span>{shipment.source.compony}</span>
              )}
            </p>

            <p className="mb-0">
              <span className="fw-bold">مبدا: </span>
              <span>
                {shipment.source.province.faName +
                  " - " +
                  shipment.source.city.faName}
              </span>
            </p>
          </div>
        </div>

        <div
          className={`border border-1 rounded-2 p-2 col-12 w-xl-45 ${
            pathname === "/tracking" ? "d-flex column-gap-2" : ""
          } justify-content-evenly mt-3`}
        >
          <div className="text-center">
            <FaAddressCard size={80} color="#482b88" />
          </div>

          <div>
            <p className="mt-1">
              <span className="fw-bold">نام گیرنده: </span>
              {shipment.destination.type === 0 && (
                <span>
                  {shipment.destination.name +
                    " " +
                    shipment.destination.family}
                </span>
              )}
              {shipment.destination.type === 1 && (
                <span>{shipment.destination.compony}</span>
              )}
            </p>

            <p className="mb-0">
              <span className="fw-bold">مقصد: </span>
              <span>
                {shipment.destination.province.faName +
                  " - " +
                  shipment.destination.city.faName}
              </span>
            </p>
          </div>
        </div>
      </div>

      <div className="mt-auto">
        <h6 className="w-100">مرسولات</h6>

        {shipment.internal_order.map(item => (
          <div
            key={item.id}
            className="border border-1 rounded-2 p-2 d-flex column-gap-2 flex-wrap justify-content-around"
          >
            <p className="w-100 text-center">
              <BsFillBoxFill size={80} color="#ee9408" />
            </p>

            <p>
              <span>محتوی: </span>
              <span>{item.shipment}</span>
            </p>

            <p>
              <span>وزن: </span>
              <span>{item.weight}</span>
              <span> (کیلوگرم)</span>
            </p>

            <p>
              <span>سایز کارتن: </span>
              <span>{getBoxSize(item.width, item.length, item.height)}</span>
            </p>

            <p className="d-flex">
              <span className="mx-1">ابعاد:</span>
              <span className="mx-1">{item.length}</span>
              <span>×</span>
              <span className="mx-1">{item.width}</span>
              <span>×</span>
              <span className="mx-1">{item.height}</span>
            </p>
          </div>
        ))}
      </div>
    </Col>
  );
};

export default SuccessShipmentBox;
